import { isActivePendingFlag } from "./recruiterOwnership";

const STORAGE_KEY = "rpo:entity-background-work";
export const ENTITY_BACKGROUND_WORK_EVENT = "rpo:entity-background-work";

const readTasks = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(parsed) ? parsed.filter((task) => task?.key) : [];
  } catch {
    return [];
  }
};

const writeTasks = (tasks) => {
  const nextTasks = Array.isArray(tasks) ? tasks.filter((task) => task?.key) : [];
  if (JSON.stringify(readTasks()) === JSON.stringify(nextTasks)) return nextTasks;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(nextTasks));
  } catch {}
  window.dispatchEvent(
    new CustomEvent(ENTITY_BACKGROUND_WORK_EVENT, { detail: { tasks: nextTasks } })
  );
  return nextTasks;
};

export const getEntityBackgroundWork = () => readTasks();

export const syncCompanyBackgroundWork = (company = {}) => {
  const id = Number(company?.id ?? company?.company_id ?? 0);
  if (!Number.isFinite(id) || id <= 0) return readTasks();

  const contactRepairPending = isActivePendingFlag(company?.contact_repair_pending);
  const profileEnrichmentPending = isActivePendingFlag(company?.company_profile_enrichment_pending);
  const key = `company:${id}`;
  const remainingTasks = readTasks().filter((task) => task.key !== key);

  if (!contactRepairPending && !profileEnrichmentPending) {
    return writeTasks(remainingTasks);
  }

  return writeTasks([
    ...remainingTasks,
    {
      key,
      entityType: "company",
      entityId: id,
      entityName: String(company?.name || company?.company_name || "Company").trim() || "Company",
      contactRepairPending,
      profileEnrichmentPending,
      updatedAt: new Date().toISOString(),
    },
  ]);
};

export const syncJobBackgroundWork = (job = {}) => {
  const id = Number(job?.id ?? job?.job_id ?? 0);
  if (!Number.isFinite(id) || id <= 0) return readTasks();

  const jobDetailsEnrichmentPending = isActivePendingFlag(job?.job_details_enrichment_pending);
  const key = `job:${id}`;
  const remainingTasks = readTasks().filter((task) => task.key !== key);

  if (!jobDetailsEnrichmentPending) {
    return writeTasks(remainingTasks);
  }

  return writeTasks([
    ...remainingTasks,
    {
      key,
      entityType: "job",
      entityId: id,
      entityName: String(job?.title || job?.job_title || "Job").trim() || "Job",
      jobDetailsEnrichmentPending,
      updatedAt: new Date().toISOString(),
    },
  ]);
};

export const replaceEntityBackgroundWork = (tasks) => writeTasks(tasks);
